var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMotor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 5803 5804",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-17.1561,0,0,17.1561,6049.9083,285.973)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 283.589,210.252 H 266.581 V 85.527 h 17.008 c 12.524,0 22.677,10.153 22.677,22.678 v 79.369 c 0,12.525 -10.153,22.678 -22.677,22.678 z M 96.502,164.897 H 62.487 V 130.882 H 96.502 V 85.527 h 73.701 V 57.181 h 45.355 v 28.346 h 39.685 v 124.725 h -28.347 v 11.623 h 22.677 v 16.723 H 136.187 v -16.723 h 22.678 V 210.252 H 96.502 Z M 113.51,125.496 H 226.964 V 107.922 H 113.51 Z m 0,28.347 H 226.964 V 136.267 H 113.51 Z m 0,28.346 H 226.964 V 164.614 H 113.51 Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotor);
export default __webpack_public_path__ + "static/media/Motor.69c699ba48817e2646e3c96d98ab7799.svg";
export { ForwardRef as ReactComponent };